export default __webpack_public_path__ + "static/media/3334 spice rack B side.88274349.png";